// export const _galleryOptions = {
//     dragToClose: true,
//     click: null,
//     closeButton: 'outside',
//     preload: 3,
//     template: {
//         closeButton: `<span>CLOSE</span>`,
//         main: `
//             <div class="fancybox__container" role="dialog" aria-modal="true" aria-hidden="true" aria-label="{{MODAL}}" tabindex="-1">
//                 <div class="fancybox__backdrop"></div>
//                 <div class="fancybox__carousel"></div>
//             </div>
//         `,
//     },
//     Image: {
//         zoom: false,
//         click: null,
//         touch: false
//     },
//     Carousel: {
//         slidesPerPage: 1,
//         Navigation: {
//             prevTpl: `<span></span>`,
//             nextTpl: `<span></span>`,
//         },
//         l10n: {
//             NEXT: " ",
//             PREV: " ",
//         }
//     },
//     Thumbs: {
//         autoStart: false,
//     },
//     Toolbar: {
//         display: [],
//     },
//     l10n: {
//         CLOSE: " ",
//     }
// }

export const galleryOptions = {
    idle: false,
    Images: {
        zoom: false,
    },
    contentClick: false,
    Thumbs: {
        type: false,
    },
    Toolbar: {
        display: {
            left: [],
            // middle: ["close"],
            right: ["close"],
        },
        items: {
            prev: {
                tpl: `<button class="f-button f-button-close" title="{{CLOSE}}" data-fancybox-close>
                    <i class="icon-close-slim"></i>
                </button>`,
            },
            next: {
                tpl: `<button class="f-button f-button-close" title="{{CLOSE}}" data-fancybox-close>
                    <i class="icon-close-slim"></i>
                </button>`,
            },
            close: {
                tpl: `<button class="f-button f-button-close" title="{{CLOSE}}" data-fancybox-close>
                    <span>CLOSE</span>
                </button>`,
            },
        },
    },
    Carousel: {
        transition: "slide",
        slidesPerPage: 1,
        Navigation: {
            prevTpl: ``,
            nextTpl: ``,
        },
        l10n: {
            NEXT: " ",
            PREV: " ",
        }
    },
}

// export const privateGalleryOptions = {
//     dragToClose: true,
//     click: null,
//     closeButton: 'outside',
//     preload: 3,
//     template: {
//         closeButton: `<span>CLOSE</span>`,
//         main: `
//             <div class="fancybox__container" role="dialog" aria-modal="true" aria-hidden="true" aria-label="{{MODAL}}" tabindex="-1">
//                 <div class="fancybox__backdrop"></div>
//                 <div class="fancybox__carousel"></div>
//                 <a id="btn-download-image" class="btn-download-image" download href="#"><img src="/public/site/nickyeconomou/dist/images/download-white.svg"alt="download all"/> <span>download this image</span></a>
//             </div>
//         `,
//     },
//     Image: {
//         zoom: false,
//         click: null,
//         touch: false
//     },
//     Carousel: {
//         slidesPerPage: 1,
//         Navigation: {
//             prevTpl: `<span></span>`,
//             nextTpl: `<span></span>`,
//         },
//         l10n: {
//             NEXT: " ",
//             PREV: " ",
//         }
//     },
//     Thumbs: {
//         autoStart: false,
//     },
//     Toolbar: {
//         display: [],
//     },
//     l10n: {
//         CLOSE: " ",
//     }
// }

export const privateGalleryOptions = {
    idle: false,
    tpl: {
        main: `<div class="fancybox__container" role="dialog" aria-modal="true" aria-label="{{MODAL}}" tabindex="-1">
            <div class="fancybox__backdrop"></div>
            <div class="fancybox__carousel"></div>
            <div class="fancybox__footer">
                <a id="btn-download-image" class="btn-download-image" download href="#">
                    <img src="/public/site/nickyeconomou/dist/images/download-white.svg" alt="download"/>
                    <span>download this image</span>
                </a>
            </div>
        </div>`,
    },
    Images: {
        zoom: false,
    },
    contentClick: false,
    Thumbs: {
        type: false,
    },
    Toolbar: {
        display: {
            left: [],
            // middle: ["close"],
            right: ["close"],
        },
        items: {
            prev: {
                tpl: `<button class="f-button f-button-close" title="{{CLOSE}}" data-fancybox-close>
                    <i class="icon-close-slim"></i>
                </button>`,
            },
            next: {
                tpl: `<button class="f-button f-button-close" title="{{CLOSE}}" data-fancybox-close>
                    <i class="icon-close-slim"></i>
                </button>`,
            },
            close: {
                tpl: `<button class="f-button f-button-close" title="{{CLOSE}}" data-fancybox-close>
                    <span>CLOSE</span>
                </button>`,
            },
        },
    },
    Carousel: {
        transition: "slide",
        slidesPerPage: 1,
        Navigation: {
            prevTpl: ``,
            nextTpl: ``,
        },
        l10n: {
            NEXT: " ",
            PREV: " ",
        }
    },
}

export default galleryOptions;